const key = Symbol();
export default {
    Components: { registeredComponents: {} },
    key,
};
